"use strict";
const React = require("react");
const $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? React.useLayoutEffect : () => {
};
exports.$f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c;
